import React from 'react';

const DeleteModal = ({ showModal, closeModal, deleteItem, text }) => {
  return (
    <div
      className={`modal ${showModal ? 'show' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: showModal ? 'block' : 'none' }}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body p-3">
            <div className='d-flex justify-content-between align-content-center mx-1'>
              <p> حذف {text} </p>
              <span className='fs-5'>
                <i className="bi bi-x-circle" role="button" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></i>
              </span>
            </div>
            <p className='fs-5 py-3 mx-1'>آیا از حذف این {text} اطمینان دارید؟</p>
            <div className="d-flex justify-content-around align-content-center">
              <button type="button" className="btn custome-btn btn-outline-purple w-50 ms-2" onClick={closeModal}>
                خیر
              </button>
              <button type="button" className="btn custome-btn btn-danger w-50 me-2" onClick={deleteItem}>
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;

